import { createRequest } from '@/utils/request';
import {
  API_RECORD_QUERY_LABEL_TREE,
  API_RECORD_TRIGGER,
  API_RECORD_MANUAL,
  API_RECORD_MANUAL_VOICE,
  API_RECORD_MANUAL_LABEL,
  API_RECORD_HISTORY,
} from '@/constants';
import type {
  RawTagNode,
  TagKind,
  HistoryRecord,
  ManualRecordParams,
  ManualRecordVoiceParams,
  ManualRecordLabelParams,
} from './types';

const recordRequest = createRequest({ code: 0 });

/**
 * 获取 FST / FIT 标签树。
 * 接口 1 返回的是**单个根节点**（树容器），其 children 才是可选的顶层标签。
 */
export function queryLabelTree(type: TagKind): Promise<RawTagNode> {
  return recordRequest.post(API_RECORD_QUERY_LABEL_TREE, { type });
}

/** 触发录包 */
export function triggerRecord(params: {
  car_id: number;
  vid: string;
  msg_id: number;
  seat_id: string;
}): Promise<boolean> {
  return recordRequest.post(API_RECORD_TRIGGER, params);
}

/** 接口 3.1 录音信息上传（录音 + 可选标签） */
export function uploadManualRecord(params: ManualRecordParams): Promise<boolean> {
  return recordRequest.post(API_RECORD_MANUAL, params);
}

/** 接口 3.2 录音单独上传（不带标签） */
export function uploadManualRecordVoice(params: ManualRecordVoiceParams): Promise<boolean> {
  return recordRequest.post(API_RECORD_MANUAL_VOICE, params);
}

/** 接口 3.3 标签单独上传（音频已存在于服务端） */
export function uploadManualRecordLabel(params: ManualRecordLabelParams): Promise<boolean> {
  return recordRequest.post(API_RECORD_MANUAL_LABEL, params);
}

/** 历史待录音打标签信息补充 */
export function fetchHistoryRecords(seatId: string): Promise<HistoryRecord[]> {
  return recordRequest.post(API_RECORD_HISTORY, { seat_id: seatId });
}
